import { render, staticRenderFns } from "./BedTime.vue?vue&type=template&id=25cbcfd0&scoped=true&"
import script from "./BedTime.vue?vue&type=script&lang=js&"
export * from "./BedTime.vue?vue&type=script&lang=js&"
import style0 from "./BedTime.vue?vue&type=style&index=0&id=25cbcfd0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cbcfd0",
  null
  
)

export default component.exports